export default __webpack_public_path__ + "static/media/React.98f81b8f.png";